import React, { ReactNode } from 'react';
import CmsComponent from '@episerver/spa-core/Components/CmsComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import HeroCarouselBlockData from 'app/Models/Content/HeroCarouselBlockData';
// these are plain .jsx React components; require them as `any` so TS accepts usage
const HeroCarousel: any = require('./Components/HeroCarousel').default;
const HeroCarouselCards: any = require('./Components/HeroCarouselCards').default;
import './HeroCarouselBlock.scss';

export default class HeroCarouselBlock extends EpiComponent<HeroCarouselBlockData> {
    public render(): ReactNode {
        const { carouselItems, cards, carouselBackgroundColor, displayDuration } = this.props.data;
console.log(this.props.data)
        const hasCards = cards?.expandedValue && cards.expandedValue.length > 0;
        return (
            <div className="hero-carousel-block" style={{ background: carouselBackgroundColor?.value || '#FFFFFF' }}>
                {carouselItems?.expandedValue && carouselItems.expandedValue.length > 0 && (
                    React.createElement(HeroCarousel, {
                        items: carouselItems.expandedValue,
                        displayDuration: (displayDuration?.value || 7) * 1000,
                        context: this.props.context,
                        hasCards: hasCards,
                    })
                )}

                {cards?.expandedValue && cards.expandedValue.length > 0 && (
                    React.createElement(HeroCarouselCards, {
                        cards: cards.expandedValue,
                        context: this.props.context,
                    })
                )}
            </div>
        );
    }
}
